import { useMemo } from 'react';
import Navbar from './../components/layout/Navbar';
import { Table } from '../components/layout/Table';
import { Link } from 'react-router-dom';
import Tabs from '../components/layout/Tabs';
import { EmailTable } from '../components/layout/EmailTable';
import { MeetingTable } from '../components/layout/MeetingTable';
import { makeUTCDateStr, makeLocalDateStr } from '../utilities/dates';
import { SelectColumnFilter } from '../utilities/tables';
import { renderArrayStr } from '../utilities/shared';

function LandingPage() {
  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        filter: 'fuzzyText',
        Cell: (e) => {
          if (e.row.canExpand) {
            return <div>{e.value}</div>;
          } else {
            const { poc_id, contact_id, name } = e.row.original;
            return (
              <Link
                to={`/summary/${name}/${contact_id}/${poc_id}`}
                style={{ color: 'blue' }}
              >
                {e.value.split('/')[0]}
              </Link>
            );
          }
        }
      },
      {
        Header: 'Title',
        accessor: 'title',
        disableSortBy: true
      },
      {
        Header: 'Affiliation',
        accessor: 'affiliation',
        disableSortBy: true
      },
      {
        Header: 'Elected',
        accessor: 'elected',
        Filter: SelectColumnFilter,
        disableSortBy: true,
        Cell: (props) => {
          return <div>{props.value ? <span> &#10003;</span> : 'X'}</div>;
        }
      },

      {
        Header: 'Counties',
        accessor: 'counties',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'HUCs',
        accessor: 'hucs',
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <>{renderArrayStr(props.value)}</>;
          } else {
            return <></>;
          }
        }
      },
      {
        Header: 'Study Areas',
        accessor: 'study_areas',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'Mitigation Areas',
        accessor: 'mitigation_areas',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'Outreach Types',
        accessor: 'outreach_types',
        disableSortBy: true,
        Cell: (props) => {
          return <p>{props.value}</p>;
        }
      },
      {
        Header: 'Email Address',
        accessor: 'email',
        disableSortBy: true
      },
      {
        Header: 'Phone Number',
        accessor: 'phone',
        disableSortBy: true
      },
      {
        Header: 'Start Date',
        accessor: 'startdate',
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p>{value ? makeUTCDateStr(value) : value}</p>;
        }
      },
      {
        Header: 'End Date',
        accessor: 'enddate',
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p>{value ? makeUTCDateStr(value) : value}</p>;
        }
      },
      {
        Header: 'Term End Date',
        accessor: 'term_enddate',
        disableSortBy: true,
        Cell: ({ value }) => {
          return <p>{value ? makeUTCDateStr(value) : value}</p>;
        }
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        disableSortBy: true
      }
    ],
    []
  );

  const meeting_columns = useMemo(
    () => [
      { Header: 'Meeting Name', accessor: 'meeting_name' },
      { Header: 'Type', accessor: 'meeting_type' },
      { Header: 'Location', accessor: 'meeting_location' },
      {
        Header: 'Date',
        accessor: 'date_time',
        Cell: ({ value }) => {
          return (
            <p>
              {value
                ? makeLocalDateStr(value, {
                    hour: 'numeric',
                    minute: 'numeric'
                  })
                : value}
            </p>
          );
        }
      },
      {
        Header: 'Document Files',
        accessor: 's3_prefix',
        disableFilters: true,
        filterable: false
      }
    ],
    []
  );

  const email_columns = useMemo(
    () => [
      { Header: 'Email Subject', accessor: 'email_subject' },
      { Header: 'Date', accessor: 'date_time' },
      {
        Header: 'Document Files',
        accessor: 's3_prefix',
        disableFilters: true,
        filterable: false
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        disableFilters: true,
        filterable: false
      }
    ],
    []
  );

  return (
    <div>
      <Navbar />
      <h2>Main Information</h2>
      <Tabs>
        <div label='Contacts'>
          <div className='wrapper'>
            <div style={{ flexGrow: '8', marginLeft: '0px', minWidth: 0 }}>
              <Table columns={columns} />
            </div>
          </div>
        </div>
        <div label='Emails'>
          <div className='wrapper'>
            <div style={{ flexGrow: '8', marginLeft: '0px', minWidth: 0 }}>
              <EmailTable columns={email_columns} />
            </div>
          </div>
        </div>
        <div label='Meetings'>
          <div className='wrapper'>
            <div style={{ flexGrow: '8', marginLeft: '0px', minWidth: 0 }}>
              <MeetingTable columns={meeting_columns} />
            </div>
          </div>
        </div>
      </Tabs>
    </div>
  );
}

export default LandingPage;


